/* eslint-disable */

import request from '../utils/request'

const isProduction = !window.location.host.includes('test');
const MBASE_URL = isProduction
  ? 'https://m.songshuai.com/api'
  : 'https://m.test.songshuai.com/api'; // 测试环境

export default {
  getChannelInfo(params) {
    return request.post({
      url: `${MBASE_URL}/school/getChannelInfo`,
      data: params,
    });
  },
  /**
   * 登录
   */
  LoginData (params) {
    return request.post({
      url: '/dlapi/home/login',
      data: params
    })
  },
   /**
   * 获取测评列表
   */
  getTestInfo (params) {
      return request.post({
        url: '/dlapi/home/api/gettestsinfo',
        data: params
      })
  },
  // /**
  //  * 登录添加用户名
  //  */
  // upDateUserinfo (params) {
  //   return request.post({
  //     url: '/home/updateuserinfo',
  //     data: params
  //   })
  // },
  // /**
  //  * 获取验证码 ---  注册
  //  */
  // getCaptcha (params) {
  //   return request.post({
  //     url: '/home/getcaptcha',
  //     data: params
  //   })
  // },
  // /**
  //  * 注册
  //  */
  // getRegister (params) {
  //   return request.post({
  //     url: '/home/register',
  //     data: params
  //   })
  // },
  // /**
  //  * 注册-登录-补充用户信息
  //  */
  // addDetail (params) {
  //   return request.post({
  //     url: '/home/adddetail',
  //     data: params
  //   })
  // },
  // /**
  //  * 找回密码
  //  */
  // findPwd (params) {
  //   return request.post({
  //     url: '/home/resetpwd',
  //     data: params
  //   })
  // },
  /**
   * 退出登录
   */
  logOut (params) {
    return request.post({
      url: '/dlapi/home/logout',
      data: params
    })
  },
  /**
   * 线下获取测试信息
   */
  // transpage (params) {
  //   return request.post({
  //     url: '/home/api/transpage',
  //     data: params
  //   })
  // },
  // /**
  //  * 获取省份列表
  //  */
  // getProvince (params) {
  //   return request.post({
  //     url: '/home/api/completeinfo',
  //     data: params
  //   })
  // },
  // /**
  //  * 获取市列表
  //  */
  // getCity (params) {
  //   return request.post({
  //     url: '/home/api/getcity',
  //     data: params
  //   })
  // },
  // /**
  //  * 获取区列表
  //  */
  // getArea (params) {
  //   return request.post({
  //     url: '/home/api/getarea',
  //     data: params
  //   })
  // },
  // /**
  //  * 获取合作校
  //  */
  // getCooperateschool (params) {
  //   return request.post({
  //     url: '/home/api/getcooperateschool',
  //     data: params
  //   })
  // },
  // /**
  //  * 补全信息默认加载
  //  */
  // completeInfo (params) {
  //   return request.post({
  //     url: '/home/api/completeinfo',
  //     data: params
  //   })
  // },
  // /**
  //  * 学校模糊查询
  //  */
  // getSchoolnamecomplete (params) {
  //   return request.post({
  //     url: '/home/api/getschoolnamecomplete',
  //     data: params
  //   })
  // },
  // /**
  //  * 补全信息提交
  //  */
  // addMsg (params) {
  //   return request.post({
  //     url: '/home/api/tocompleteinfo',
  //     data: params
  //   })
  // },
  // /**
  //  * 获取科目分类
  //  */
  // getCategory (params) {
  //   return request.post({
  //     url: '/home/api/getcategory',
  //     data: params
  //   })
  // },
  /**
   * 获取试题数量
   */
  getQuestionnum (params) {
    return request.post({
      url: '/dlapi/home/api/getquestionnum',
      data: params
    })
  },
  /**
   * 开始测评
   */
  testStart (params) {
    return request.post({
      url: '/dlapi/home/api/teststart',
      data: params
    })
  },
  /**
   * 获取历史报告
   */
  getHistoryreport (params) {
    return request.post({
      url: '/home/api/gethistoryreport',
      data: params
    })
  },
  /**
   * 获取题目信息
   */
  getQuestioninfo (params) {
    return request.post({
      url: '/dlapi/home/api/getquestioninfo',
      data: params
    })
  },
  /**
   * 提交答案
   */
  submitQuestionanswer (params) {
    return request.post({
      url: '/dlapi/home/api/submitquestionanswer',
      data: params
    })
  },
  /**
   * 获取题目信息v5
   */
  getQuestioninfoV5 (params) {
    return request.post({
      url: '/dlapi/home/api/go',
      data: params
    })
  },
  /**
   * 提交答案v5
   */
  submitQuestionanswerV5 (params) {
    return request.post({
      url: '/dlapi/home/api/submit',
      data: params
    })
  },
  /**
   * 获取报告页第一部分
   */
  getReportpart1 (params) {
    return request.post({
      url: '/dlapi/report/api/getreportpart1',
      data: params
    })
  },
  /**
   * 获取报告页第二部分
   */
  getReportpart2 (params) {
    return request.post({
      url: '/dlapi/report/api/getreportpart2',
      data: params
    })
  },
  /**
   * 获取报告页第三部分
   */
  getReportpart3 (params) {
    return request.post({
      url: '/dlapi/report/api/getreportpart3',
      data: params
    })
  },

   /**
   * 获取学生最后一次完成的数据
   */
    getLastInfo (params) {
      return request.post({
        url: '/dlapi/home/api/getlastinfo',
        data: params
      })
    },
  /**
   * 获取题目详情
   */
  getQuestiondetail (params) {
    return request.post({
      url: '/dlapi/report/api/getquestiondetail',
      data: params
    })
  },
  /**
   * 获取学生列表
   */
  studentList (params) {
    return request.post({
      url: '/admin/sales/studentlist',
      data: params
    })
  },
  /**
   * 获取分类关系
   */
  getDlrelated (params) {
    return request.post({
      url: '/admin/sales/getdlrelated',
      data: params
    })
  },
  /**
   * 班级报告头部
   */
  classReport (params) {
    return request.post({
      url: '/report/api/classreport',
      data: params
    })
  },
  /**
   * 整体掌握情况
   */
  getPartoneinfo (params) {
    return request.post({
      url: '/report/api/getpartoneinfo',
      data: params
    })
  },
  /**
   * 知识点平均掌握情况
   */
  getParttwoinfo (params) {
    return request.post({
      url: '/report/api/getparttwoinfo',
      data: params
    })
  },
  /**
   * 知识点分析——知识点数量
   */
  getPartthreetagcode (params) {
    return request.post({
      url: '/report/api/getpartthreetagcode',
      data: params
    })
  },
  /**
   * 知识点分析——单个知识点详情
   */
  getPartthreetagcodedetail (params) {
    return request.post({
      url: '/report/api/getpartthreetagcodedetail',
      data: params
    })
  },
  /**
   * 线下获取测试信息
   */
  // getTestinfo (params) {
  //   return request.post({
  //     url: '/home/api/gettestinfo',
  //     data: params
  //   })
  // },
  // 获取省市列表
  getCityList (params) {
    return request.post({
      url: '/home/api/getcitylist',
      data: params
    })
  },
  // 获取公校列表
  getSchoolList (params) {
    return request.post({
      url: '/home/api/getschoollist',
      data: params
    })
  }
}
